import { render } from "./SlidePatner.vue?vue&type=template&id=54192af4"
import script from "./SlidePatner.vue?vue&type=script&lang=js"
export * from "./SlidePatner.vue?vue&type=script&lang=js"

import exportComponent from "C:\\thangpn\\code\\free\\frontend-amber-hills\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__